import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import cn from 'classnames';
import { useLocalizedPriceFormatter } from 'tradera/localization/use-localized-price-formatter';

const CombinedShippingBadge = ({
    days,
    freeShippingCostLimit,
    className = ''
}) => {
    const { t } = useTranslator();
    const localizedPriceFormatter = useLocalizedPriceFormatter();

    return (
        <div
            className={cn(
                'd-inline-flex align-items-center flex-wrap text-inter-medium gap-1',
                className
            )}>
            <div className="badge badge-dark">
                {t('combinedShippingBadge_title')}
            </div>
            {days !== undefined && (
                <span>
                    {t('combinedShippingBadge_count_days', {
                        count: days
                    })}
                </span>
            )}
            {freeShippingCostLimit && (
                <>
                    <span>|</span>
                    <span>
                        {t('combinedShippingUpsell_freeShipping_localized', {
                            amount: localizedPriceFormatter(
                                freeShippingCostLimit
                            )
                        })}
                    </span>
                </>
            )}
        </div>
    );
};

export { CombinedShippingBadge };
